import { Skeleton, Stack, useMediaQuery, useTheme } from '@mui/material'
import type { FC } from 'react'

import { COLORS, unit } from '@hcr/ui'

import { LayoutNavigation } from '../../common/layout-navigation'

export const OwnerHoldingsNotVisibleLoading: FC = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))

  return (
    <LayoutNavigation showSideNavigation={false}>
      <Stack>
        <Stack paddingLeft={unit(isMobile ? 6.5 : 25)} paddingTop={unit(2)}>
          <Skeleton width='10%' height={unit(16)} sx={{ bgcolor: COLORS.white }} variant='rectangular' />
        </Stack>
        <Stack
          direction='column'
          paddingLeft={unit(isMobile ? 6.5 : 25)}
          paddingRight={unit(isMobile ? 8 : 25)}
          gap={unit(4.5)}
        >
          <Stack
            direction='column'
            gap={unit(3)}
            alignItems='center'
            justifyContent='center'
            textAlign='center'
            paddingLeft={unit(17.5)}
            paddingRight={unit(20)}
          >
            <Skeleton width='20%' height={unit(25)} sx={{ bgcolor: COLORS.white }} variant='rectangular' />
            <Skeleton width='95%' height={unit(10)} sx={{ bgcolor: COLORS.white }} variant='rectangular' />
            <Skeleton width='95%' height={unit(10)} sx={{ bgcolor: COLORS.white }} variant='rectangular' />
          </Stack>
          <Stack paddingLeft={unit(isMobile ? 0 : 6.5)} paddingRight={isMobile ? 0 : unit(8)} gap={unit(1.5)}>
            <Skeleton width='95%' height={unit(6)} sx={{ bgcolor: COLORS.white }} variant='rectangular' />
            <Skeleton width='95%' height={unit(6)} sx={{ bgcolor: COLORS.white }} variant='rectangular' />
            <Skeleton width='95%' height={unit(6)} sx={{ bgcolor: COLORS.white }} variant='rectangular' />
            <Skeleton width='95%' height={unit(6)} sx={{ bgcolor: COLORS.white }} variant='rectangular' />
            <Skeleton width='95%' height={unit(6)} sx={{ bgcolor: COLORS.white }} variant='rectangular' />
            <Skeleton width='95%' height={unit(6)} sx={{ bgcolor: COLORS.white }} variant='rectangular' />
            <Skeleton width='95%' height={unit(6)} sx={{ bgcolor: COLORS.white }} variant='rectangular' />
          </Stack>
        </Stack>
        <Stack
          direction='column'
          paddingTop={unit(8)}
          paddingX={unit(isMobile ? 7.5 : 32.5)}
          paddingBottom={unit(isMobile ? 10 : 20)}
        >
          <Skeleton width='95%' height={unit(15)} sx={{ bgcolor: COLORS.white }} variant='rectangular' />
        </Stack>
      </Stack>
    </LayoutNavigation>
  )
}
